import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cigna-modal-layout-control',
  template: '<ng-content></ng-content>',
  styleUrls: ['./modal-layout-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalLayoutControlComponent {}
